import type { ReactNode } from "react";
import type { Optional } from "../../../types";
import type { VehicleCardImageProps } from "../vehicle-card.component";
import styles from "./vehicle-card-image-mobile.module.css";

export type VehicleCardImageMobileProps = {
  children: ReactNode;
  src?: Optional<string>;
  title: string;
  index: number;
  onImageRender?: Optional<(props: VehicleCardImageProps) => ReactNode>;
};

export function VehicleCardImageMobile({
  onImageRender,
  children,
  title,
  index,
  src,
}: Readonly<VehicleCardImageMobileProps>) {
  const props = {
    src: src!,
    title,
    index,
    height: 102,
    width: 102,
    alt: title,
    className: styles.Image,
    isActive: true,
  };

  return (
    <div className={styles.Container}>
      {onImageRender ? onImageRender(props) : <img {...props} />}
      {children}
    </div>
  );
}
